import type { EntryIconId } from '@trove/core';

export const ENTRY_ICON_OPTIONS: Array<{
  id: EntryIconId;
  label: string;
  emoji: string;
}> = [
  { id: 'folder', label: 'Folder', emoji: '📁' },
  { id: 'file', label: 'File', emoji: '📄' },
  { id: 'heart', label: 'Heart', emoji: '❤️' },
  { id: 'shield', label: 'Shield', emoji: '🛡️' },
  { id: 'key', label: 'Key', emoji: '🔑' },
  { id: 'wallet', label: 'Wallet', emoji: '👛' },
  { id: 'card', label: 'Card', emoji: '💳' },
  { id: 'id', label: 'ID', emoji: '🪪' },
  { id: 'lock', label: 'Lock', emoji: '🔒' },
  { id: 'star', label: 'Star', emoji: '⭐' },
  { id: 'bookmark', label: 'Bookmark', emoji: '🔖' },
  { id: 'pill', label: 'Pill', emoji: '💊' },
  { id: 'stethoscope', label: 'Health', emoji: '🩺' },
  { id: 'home', label: 'Home', emoji: '🏠' },
  { id: 'briefcase', label: 'Work', emoji: '💼' },
  { id: 'globe', label: 'Web', emoji: '🌐' },
];

export function entryIconEmoji(id: EntryIconId | undefined) {
  if (!id) return undefined;
  return ENTRY_ICON_OPTIONS.find((entry) => entry.id === id)?.emoji;
}
